import { JSX } from "react";

import { NavigateNext } from "@mui/icons-material";
import { Breadcrumbs, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useBreadcrumbsDataQuery } from "src/api/locationQueries.api";
import { type LocationModel } from "src/types/location";

function FilesPageBreadcrumbsComponent({
  selectedFileName,
  selectedLocation,
  rootLocation,
}: {
  selectedFileName: string | undefined;
  selectedLocation: LocationModel | undefined;
  rootLocation: LocationModel | undefined;
}): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: breadcrumbsData } = useBreadcrumbsDataQuery(selectedLocation?.Id);

  const dashboardItem: ApiBreadcrumbItemDto = { id: rootLocation?.Id ?? "/", name: t("files") };
  const fileName: ApiBreadcrumbItemDto = { id: "", name: selectedFileName ?? "" };

  const breadcrumbsToDisplay = [dashboardItem, ...(breadcrumbsData ?? []), ...(selectedFileName ? [fileName] : [])];

  return (
    <Breadcrumbs aria-label='breadcrumb' separator={<NavigateNext fontSize='small' />}>
      {breadcrumbsToDisplay.map((breadcrumbItem: ApiBreadcrumbItemDto, i: number) => {
        const disable = breadcrumbsToDisplay.length - i - 1 === 0 || breadcrumbItem.id === "/";
        if (!disable) {
          return (
            <Link
              key={breadcrumbItem.id}
              underline='hover'
              color='text.primary'
              onClick={(e) => {
                e.preventDefault();
                navigate(`/files/${breadcrumbItem.id}`);
              }}
            >
              {breadcrumbItem.name}
            </Link>
          );
        }
        return (
          <Typography key={breadcrumbItem.id} color='inherit'>
            {breadcrumbItem.name}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
}

export default FilesPageBreadcrumbsComponent;
